import officialHtml from "./official.html?raw";

export interface MailingTemplateMeta {
  id: string;
  label: string;
  description: string;
  defaultSubject: string;
  defaultPreheader: string;
  html: string;
}

export const MAILING_TEMPLATES: MailingTemplateMeta[] = [
  {
    id: "official",
    label: "Plantilla oficial TVS",
    description: "Header con logo + zona de contenido editable + redes sociales y footer corporativo.",
    defaultSubject: "Tenemos novedades para ti",
    defaultPreheader: "Mira lo que preparamos esta semana en TVS",
    html: officialHtml,
  },
];

export const DEFAULT_TEMPLATE = MAILING_TEMPLATES[0];
